exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".related-cases table tbody tr:last-child td{border-bottom:0}.related-cases .case-label{text-align:center;margin:20px 0}.related-cases .messages{margin-bottom:30px}.related-cases .live_search{margin-top:15px;margin-bottom:30px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/case/associated_cases/RelatedCases.less
 ** module id = 1072
 ** module chunks = 0
 **/